<template>
    <div class="d-flex">
        <div style="width: 100% !important;">
            <label class="estilo-label">
                <span v-if="campo && tela">
                    <label-personalizado
                        :campo="campo"
                        :tela="tela"
                        :obrigatorioPorPadrao="obrigatorio"
                        :apresentaTooltip="Boolean(mensagemPadraoTooltip)"
                        :mensagemPadraoTooltip="mensagemPadraoTooltip"
                    />
                </span>

                <span v-else>
                    Arquivo
                    <span v-if="obrigatorio" class="ml-1 red--text">*</span>
                </span>
            </label>

            <div
                class="d-flex align-center justify-center highlight-area"
                style="height: 150px; width: 100% !important;"
                @drop="onDrop"
                @dragover="onDragOver"
                @click="onClickImportFile"
            >
                <p class="subtitle-2 font-weight-bold text-center grey--text">
                    <v-icon size="25">fas fa-file-upload</v-icon>
                    <br/><br/>
                    <input
                        id="import-ele-input_file"
                        type="file"
                        style="display: none;"
                        :accept="extensoesPermitidas"
                    >
                    <span v-if="nomeArquivos" v-html="nomeArquivos"/>
                    <span v-else>Selecione ou arraste seu arquivo aqui.</span><br/>
                </p>
            </div>
            <span class="text-caption grey--text">
                Tamanho máximo permitido: 15Mb
            </span>

            <div class="v-text-field__details" v-if="obrigatorio && !nomeArquivos && valida">
                <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__messagee">
                            O campo é obrigatório
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LabelPersonalizado from '@/views/components/label/LabelPersonalizado'

    export default {
        name: 'CampoArquivoDragAndDrop',

        components: {
            LabelPersonalizado
        },

        data() {
            return {
                nomeArquivos: null,
                valida: false
            }
        },

        props: {
            multiplosArquivosPermitidos: {
                type: Boolean,
                default: false
            },
            extensoesPermitidas: {
                type: Array,
                default: () => []
            },
            obrigatorio: {
                type: Boolean,
                default: false
            },
            campo: {
                type: String,
                default: undefined
            },
            tela: {
                type: String,
                default: undefined
            },
            mensagemPadraoTooltip: {
                type: String,
                default: undefined
            }
        },

        computed: {
            extensoesPermitidasFormatadas() {
                return this.extensoesPermitidas.join(', ')
            }
        },

        methods: {
            onDrop(e) {
                e = e || window.event
                e.preventDefault()
                const files = this.constroiListaArquivos(e)

                this.nomeArquivos = files.map(file => file.name).join('<br/>')

                if (this.validarArquivosPermitidos(files)) return

                this.$emit('files', (this.multiplosArquivosPermitidos) ? files : files[0])
            },
            constroiListaArquivos(e) {
                if (e.dataTransfer.items) {
                    if (!this.multiplosArquivosPermitidos) return [e.dataTransfer.items[0].getAsFile()]

                    return Array(e.dataTransfer.items)
                        .filter(item => item.kind === 'file')
                        .map(item => item.getAsFile())
                }

                return [...e.dataTransfer.files]
            },
            onDragOver(e) {
                e.preventDefault()
            },
            onClickImportFile() {
                const inputEle = document.getElementById('import-ele-input_file')

                if (!inputEle) return

                inputEle.value = null

                inputEle.setAttribute('type', 'file')

                if (this.multiplosArquivosPermitidos) {
                    inputEle.setAttribute('multiple', '')
                } else {
                    inputEle.removeAttribute('multiple')
                }

                inputEle.removeEventListener('change', this.processarArquivosEventoClique)

                inputEle.addEventListener('change', this.processarArquivosEventoClique)

                inputEle.click()
            },
            processarArquivosEventoClique(e) {
                e = e || window.event
                this.nomeArquivos = [...e.target.files].map(file => file.name).join('<br/>')

                if (this.validarArquivosPermitidos(e.target.files)) return
                this.$emit('files', (this.multiplosArquivosPermitidos) ? e.target.files : e.target.files[0])
            },
            validarArquivosPermitidos(files) {
                for (const file of files) {
                    if (this.extensaoArquivoInvalida(file.name)) {
                        return this.mensagemErroArquivosPermitidos('Extensão do arquivo inválida. Envie arquivos nos seguintes formatos: ' + this.extensoesPermitidasFormatadas)
                    } else if (this.tamanhoMaximoExcedido(file.size)) {
                        return this.mensagemErroArquivosPermitidos('Não é permitido inserir arquivos maiores que 15Mb.')
                    }
                }

                return false
            },
            mensagemErroArquivosPermitidos(msg) {
                this.mostrarNotificacaoErro(msg)
                this.$emit('files', null)
                this.limparArquivos()
                return true
            },
            extensaoArquivoInvalida(nomeArquivo) {
                const extensao = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'), nomeArquivo.length)
                return (this.extensoesPermitidas.map(extensaoPermitida => extensaoPermitida.toLowerCase()).indexOf(extensao.toLowerCase()) === -1)
            },
            tamanhoMaximoExcedido(tamanhoAnexo) {
                return tamanhoAnexo >= 15116247
            },
            limparArquivos() {
                this.nomeArquivos = null
            },
            validarEnvioObrigatorio() {
                if (this.obrigatorio) this.valida = this.nomeArquivos == null
                return !this.valida
            },
            resetValidacao() {
                this.valida = false
            }
        }
    }
</script>

<style scoped lang="stylus">
    .highlight-area
        border 1.8px dashed rgb(185, 185, 185)
        background-color #eeeeee !important
        padding 12px 18px
</style>
